
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (ApiController.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------


const _distribution_WordpressControllerHelper = new Map<string, Object>();


export const distribution_WordpressControllerHelper = _distribution_WordpressControllerHelper;

